import Pricingpage from "../components/sections/pricingpage"



const Pricing =() =>{
    return(
        <div>
            <Pricingpage />
        </div>
    )
}

export default Pricing